import { Button } from "semantic-ui-react";
import { stylesConfig } from "../helpers/stylesConfig";
import SignInUp from "./SignInUp/SignInUp";
import useDeviceType from "../hook/useDeviceType";
import { useLocation, useNavigate } from "react-router";
import { isLoggedIn } from "../utils/isLoggedIn";
import SignInData from "./SignInUp/SignInData";
import Balance from "./SignInUp/components/Balance";
import { COMMON_ALT, MENU_LIST } from "../constant";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import ColorSwitcher from "../pages/MenuBar/components/colorSwitcher";
import LanguageSettings from "../pages/Settings/components/LanguageSettings";
import { BiSearch } from "react-icons/bi";
import IconCircleWrapper from "./Icon/IconCircleWrapper";
import { getInboxList } from "../api/getApi";
import { testSocket } from "../api/postApi";

const Header = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const deviceType = useDeviceType();

  const navigate = useNavigate();
  const location = useLocation();

  const pathNow = useMemo(() => {
    return location.pathname;
  }, [location.pathname]);

  const headerMenu = [
    { text: "SLOTS", link: "/casino" },
    // { text: "SLOTS", link: "/slots" },
    { text: "LIVE CASINO", link: "/live-casino" },
    { text: "SPORTS", link: "/sports" },
    { text: "LOTTERY", link: "/lottery" },
    { text: "PROMOTION", link: "/promotion" },
  ];

  return (
    <header
      className={`${
        deviceType === "PC" ? "w-full" : "w-full"
      } sm:h-[56px] h-[50px] fixed top-0 right bg-base-light-white dark:bg-base-light-dark z-[999] md:border-b-0 border-b border-base-white dark:border-base-dark md:header-shadow flex items-center justify-between`}
    >
      <section className="flex items-center justify-between px-common-padding-x w-full sm:max-w-[1440px] lg:min-w-[1024px] sm:mx-auto h-full">
        <section className="flex items-center text-light-white">
          {/* <img
            src={stylesConfig.mainLogo}
            className="w-[80px] md:w-[94px] cursor-pointer mr-[16px]"
            onClick={() => navigate("/")}
          /> */}
          <img //用三元運算 (? :) 去判斷 如果已登入就顯示 stylesConfig.loggedInLogo 圖片，否則顯示 stylesConfig.mainLogo 圖片
            onClick={() => {
              navigate("/casino");
            }}
            src={
              isLoggedIn() ? stylesConfig.loggedInLogo : stylesConfig.mainLogo
            }
            className={`cursor-pointer mr-[50px] ${
              isLoggedIn() ? "w-[29px]" : "w-[80px] md:w-[94px]"
            }`}
            alt={COMMON_ALT}
            style={{ pointerEvents: "all" }}
          />

          <nav className="md:flex gap-[10px] hidden py-[8px]">
            {headerMenu.map((item, index) => {
              return (
                <NavLink
                  to={item.link}
                  key={`${item}-${index}`}
                  className={({ isActive, isPending }) =>
                    isPending
                      ? "pending"
                      : isActive
                      ? "bg-base-white dark:bg-base-dark text-black dark:text-base-light-white hover:dark:text-base-light-white py-[10px] rounded-[5px] text-dark-gray-text hover:text-black hover:bg-base-white justify-center px-[15px] cursor-pointer"
                      : " py-[10px] rounded-[5px] text-dark-gray-text hover:text-black hover:bg-base-white hover:dark:bg-base-dark dark:!text-base-light-white justify-center px-[15px] cursor-pointer"
                  }
                  //  className={`${
                  //   pathNow === item.link && "bg-[#eee] text-black"
                  // } py-[10px] rounded-[5px] text-dark-gray-text hover:text-black hover:bg-[#eee] justify-center px-[15px] cursor-pointer`}
                >
                  {i18n(item.text.toLowerCase())}
                </NavLink>
              );
            })}
          </nav>
        </section>
        {isLoggedIn() && (
          <section className="flex md:hidden">
            <Balance />
          </section>
        )}
        {/* <button
          type="button"
          onClick={() => {
            testSocket();
          }}
        >
          123123
        </button> */}
        <section className="flex items-center gap-[15px] justify-end">
          <div className="md:flex hidden gap-[15px] items-center">
            <IconCircleWrapper
              divProps={{
                onClick: () => navigate("search"),
              }}
              className={`hidden md:flex min-h-[38px] min-w-[38px]`}
            >
              <BiSearch className="text-xl" />
            </IconCircleWrapper>
            {isLoggedIn() ? (
              <Balance />
            ) : (
              <>
                <LanguageSettings className="" />
                <ColorSwitcher wordHidden />
              </>
            )}
          </div>
          {isLoggedIn() ? (
            <>
              <SignInData />
            </>
          ) : (
            <SignInUp Static />
          )}
        </section>
        {/* <img src={stylesConfig.mainLogo} className="object-cover w-[100px]" /> */}
      </section>
    </header>
  );
};

export default Header;
